module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0662.c47242c4.jpg";